import moment from 'moment';
import { getQTDIntervals, getYTDIntervals } from './intervalpicker-utils';

import {
    PREVIOUS_7_DAYS,
    PREVIOUS_30_DAYS,
    PREVIOUS_MONTH,
    PREVIOUS_QUARTER,
    PREVIOUS_YEAR,
    QUARTER_TO_DATE,
    YEAR_TO_DATE,
} from '../common/constants/definitions';

import {
    dateOptionMap,
} from '../common/constants/date-options';

const dateOptions = ( option ) => {
    const optionData = dateOptionMap[option];
    return {
        label: `${optionData.display} (${moment( optionData.start ).format( 'YYYY/MM/DD' )} - ${moment( optionData.end ).format( 'YYYY/MM/DD' )})`,
        value: optionData.diff
    };
};

const reportDateOptions = ( option ) => {
    return dateOptionMap[option];
};

export const addDynamicOptions = ( options, qtdOptions, ytdOptions ) => {
    if( qtdOptions.length > 0 ){
        options.push( reportDateOptions( QUARTER_TO_DATE ) );
    }

    if( ytdOptions.length > 0 ){
        options.push( reportDateOptions( YEAR_TO_DATE ) );
    }
};

const dateOptionHasNoData = ( option, optionType, intervals ) => {
    return option === optionType && intervals().length === 0;
};

export const buildDateOptions = ( type ) => {
    let options;
    switch( type ){
        case 'basic':
        default:
            options = [
                dateOptions( PREVIOUS_7_DAYS ),
                dateOptions( PREVIOUS_30_DAYS ),
            ];
    }
    return options;
};

export const buildReportDateOptions = ( isDomainPortfolio ) => {
    let options;
    if( isDomainPortfolio ){
        options = [
            reportDateOptions( PREVIOUS_7_DAYS ),
            reportDateOptions( PREVIOUS_30_DAYS ),
        ];
    }
    else{
        options = [
            reportDateOptions( PREVIOUS_30_DAYS ),
            reportDateOptions( PREVIOUS_MONTH ),
            reportDateOptions( PREVIOUS_QUARTER ),
            reportDateOptions( PREVIOUS_YEAR ),
        ];
        addDynamicOptions( options, getQTDIntervals(), getYTDIntervals() );
    }
    return options;
};

export const evalDateOption = ( option ) => {
    const defaultOption = PREVIOUS_YEAR;
    if( dateOptionHasNoData( option, QUARTER_TO_DATE, getQTDIntervals ) ||
        dateOptionHasNoData( option, YEAR_TO_DATE, getYTDIntervals ) ){
        return defaultOption;
    }
    return option;
};
